import { Card, Skeleton, Typography } from "@mui/material";

export function BookingTableFormSkeleton() {
    return (
        <>
            <Typography variant="h4" gutterBottom>
                Bookings
            </Typography>
            <Card>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="100%"
                    height="50vh"
                />
            </Card>
        </>
    );
}
